module.exports = __webpack_public_path__ + "img/leo-photo.55a0114e.png";